<div class="bg-primary text-center">
  <h2 mat-dialog-title class="mat-mdc-dialog-title text-white">{{data.title}}</h2>
</div>

<mat-dialog-content class="mat-mdc-dialog-content text-center">
  <div class="col-md-12">
    <div class="title">{{data.message}}</div>
  </div>
  <mat-divider style="margin-top: 30px;"></mat-divider>
  <div class="divBtns">
    <!-- Updated By Youssef Yahya -->

    <button *ngIf="data.cancelText" class="m-r-5 btn w-100" [mat-dialog-close]="false">{{data.cancelText}}</button>
    <button class="m-r-5 btn w-100" [mat-dialog-close]="true">
      {{data.confirmText}}
    </button>
  </div>
</mat-dialog-content>
